import { syncHistoryWithStore } from 'react-router-redux'
import { browserHistory } from 'react-router'
import auditTrailService from '../services/audit-trail'

const getConnectedHistory = (store) => {
  const history = syncHistoryWithStore(browserHistory, store)
  history.listen((location) => {
    if (location.pathname.startsWith('/admin')) {
      auditTrailService.trackPageView(location.pathname)
    }
  })

  return history
}

export default getConnectedHistory
